'use client';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Cbutton } from '@/components/ui/Cbutton';
import { ButtonPreset, ContainerPreset } from '@/constants/componentPresets';
import { getWitnessCardRootStyle, getWitnessCardSurfaceStyle, WITNESS_CARD_MOTION_WRAPPER_STYLE, } from './cwitnesscardStyles';
import { CwitnesscardContent, CwitnesscardGradientOverlay, } from './CwitnesscardContent';
import { CwitnesscardHoverPrompt } from './CwitnesscardHoverPrompt';
import { AnimatedWitnessCardImage } from './CwitnesscardImage';
import { useCwitnesscardMotion } from './useCwitnesscardMotion';
import type { CwitnesscardProps } from './Cwitnesscard.types';
export function CwitnesscardAnimated({ data, isSticky, onClick, layoutId, className, style, scrollContainerRef, }: CwitnesscardProps) {
    const [isHovered, setIsHovered] = useState(false);
    const { brightnessFilter, cardRef, imageWrapperOpacity, imageWrapperY, opacity, scale, } = useCwitnesscardMotion({ scrollContainerRef });
    return <div data-el="Cwitnesscard/Root" ref={cardRef} className={className} style={getWitnessCardRootStyle({ isSticky, style })}>
            <motion.div layoutId={layoutId} style={{
            ...WITNESS_CARD_MOTION_WRAPPER_STYLE,
            scale,
            opacity,
        }}>
                <Cbutton preset={ButtonPreset.Ghost} containerPreset={ContainerPreset.WitnessCard} ariaLabel={onClick ? `Open ${data.title}` : undefined} padding={0} onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} disableHoverEffects={!onClick} style={{ width: "100%", height: "100%" }} containerStyle={{ ...getWitnessCardSurfaceStyle({ isAnimated: true, isSticky }), width: "100%", height: "100%" }}>
                    <AnimatedWitnessCardImage brightnessFilter={brightnessFilter} data={data} imageWrapperOpacity={imageWrapperOpacity} imageWrapperY={imageWrapperY} isHovered={isHovered}/>
                    <CwitnesscardGradientOverlay />
                    <CwitnesscardContent data={data} isSticky={isSticky}/>
                    <CwitnesscardHoverPrompt isHovered={isHovered}/>
                </Cbutton>
            </motion.div>
        </div>
        ;
}
